// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';

// img
import multiDownloadImg from '../img/mult_download.png';

function Gaap05(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <div className="content_text">
                Genome annotation refers to the process of identifying and 
                attaching all the relevant features on a genome sequence. 
                Genome annotation is divided into structural annotation 
                and functional annotation.
            </div>
            <h2 className="content_title2">Structural annotation</h2>
            <div className="content_text">
                Structural annotation is the process of using assembled 
                base sequence data to identify gene locations and structure, 
                such as exons, introns, UTRs, and codons constituting these genes.
            </div>
            <h2 className="contnet_description">(1) Repeat identification</h2>
            <div className="content_text">
                Prior to gene prediction, it is important to mask 
                repetitive elements, including low-complexity regions 
                and transposable elements. GAAP uses RepeatMasker for 
                repeat masking. RepeatMasker employs the Repbase as a library.
            </div>
            <div className="content_command_title">RepeatMasker</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={multiDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/>
                    <DownloadLinks link=" http://repeatmasker.org (RepeatMasker)" /><br/>
                    <DownloadLinks link=" http://www.girinst.org/repbase/update/index.html (Repbase)" />
                </div>
            </div><br/>
            <li className="content_description">RepeatMasker Command</li>
            <CommandBox lines={[
                {data:
                    `RepeatMasker -–species species.name genome.fasta`
                },
            ]}
            /><br/>
            <li className="content_description">Options for RepeatMasker</li>
            <OptionTable
                data={[
                    {   option:'--species',
                        desc:'specify the name of the species in repeat library'},
                ]}
            /><br />
            <li className="content_description">Output of RepeatMasker</li>
            <div className="content_text">
                genome.fasta: stores the repeat masked scaffold sequences.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap04"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap06"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap05;